// client/src/components/StatusBadge.jsx
import React from "react";

const STATUS_CONFIG = {
  // Financial
  paid:               { bg: "#dcfce7", color: "#15803d", dot: "#22c55e", label: "Paid" },
  pending:            { bg: "#fef9c3", color: "#854d0e", dot: "#eab308", label: "Pending" },
  refunded:           { bg: "#fee2e2", color: "#b91c1c", dot: "#ef4444", label: "Refunded" },
  partially_refunded: { bg: "#ffedd5", color: "#c2410c", dot: "#f97316", label: "Part. Refunded" },
  voided:             { bg: "#f3f4f6", color: "#6b7280", dot: "#9ca3af", label: "Voided" },
  authorized:         { bg: "#ede9fe", color: "#6d28d9", dot: "#8b5cf6", label: "Authorized" },
  partially_paid:     { bg: "#fef3c7", color: "#92400e", dot: "#f59e0b", label: "Part. Paid" },
  unpaid:             { bg: "#fee2e2", color: "#b91c1c", dot: "#ef4444", label: "Unpaid" },
  // Fulfillment
  fulfilled:          { bg: "#dbeafe", color: "#1d4ed8", dot: "#3b82f6", label: "Fulfilled" },
  unfulfilled:        { bg: "#f3f4f6", color: "#4b5563", dot: "#9ca3af", label: "Unfulfilled" },
  partial:            { bg: "#fef3c7", color: "#92400e", dot: "#f59e0b", label: "Partial" },
  shipped:            { bg: "#d1fae5", color: "#065f46", dot: "#10b981", label: "Shipped" },
  unshipped:          { bg: "#f3f4f6", color: "#4b5563", dot: "#9ca3af", label: "Unshipped" },
  cancelled:          { bg: "#fee2e2", color: "#b91c1c", dot: "#ef4444", label: "Cancelled" },
  cancelled_location_changed: { bg: "#fce7f3", color: "#9d174d", dot: "#ec4899", label: "Cancelled & Location Changed" },
  partial_fulfilled_location_changed: { bg: "#fff7ed", color: "#9a3412", dot: "#f97316", label: "Partial Fulfilled & Loc Changed" },
  location_disabled:  { bg: "#fef3c7", color: "#92400e", dot: "#f59e0b", label: "Location Disabled" },
  stale_pending:      { bg: "#fef3c7", color: "#92400e", dot: "#f59e0b", label: "Stale (Refreshing)" },
};

export const StatusBadge = ({ status, size = "sm" }) => {
  const cfg = STATUS_CONFIG[status] || { bg: "#f3f4f6", color: "#6b7280", dot: "#9ca3af", label: status };
  const padding = size === "lg" ? "5px 14px" : "3px 10px";
  const fontSize = size === "lg" ? "13px" : "11px";

  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      padding, borderRadius: 20, fontSize, fontWeight: 700,
      letterSpacing: "0.03em", background: cfg.bg, color: cfg.color,
      whiteSpace: "nowrap",
    }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: cfg.dot, flexShrink: 0 }} />
      {cfg.label}
    </span>
  );
};

export default StatusBadge;
